import React, { useState, useRef } from 'react';
import { NavLink, Link } from 'react-router-dom';

const links = [
  { to: '/',             label: 'Home'         },
  { to: '/services',     label: 'Services'     },
  { to: '/about',        label: 'About'        },
  { to: '/team',         label: 'Our Team'     },
  { to: '/testimonials', label: 'Reviews'      },
  { to: '/contact',      label: 'Contact'      },
];

export default function Navbar({ scrolled }) {
  const [open, setOpen] = useState(false);
  const hamRef = useRef(null);

  const toggleMenu = () => {
    setOpen(o => !o);
    const spans = hamRef.current?.querySelectorAll('span');
    if (spans) {
      const next = !open;
      spans[0].style.transform = next ? 'rotate(45deg) translate(5px,5px)' : '';
      spans[1].style.opacity   = next ? '0' : '';
      spans[2].style.transform = next ? 'rotate(-45deg) translate(5px,-5px)' : '';
    }
  };

  const close = () => {
    setOpen(false);
    const spans = hamRef.current?.querySelectorAll('span');
    if (spans) spans.forEach(s => { s.style.transform = ''; s.style.opacity = ''; });
  };

  return (
    <nav className={`navbar${scrolled ? ' scrolled' : ''}`}>
      <div className="nav-container">
        <Link to="/" className="nav-logo spacex-logo" onClick={close}>
          <img src="/logo2.png" alt="Dant Sanjeevani logo" className="site-logo-image" />
          <span className="site-logo-copy" aria-hidden="true">
            <span className="site-logo-title">DANT SANJEEVANI</span>
            <span className="site-logo-tagline">MAXILLOFACIAL &amp; CLEFT CLINIC</span>
          </span>
        </Link>

        <ul className={`nav-links${open ? ' open' : ''}`}>
          {links.map(({ to, label }) => (
            <li key={to}>
              <NavLink
                to={to}
                end
                className={({ isActive }) => isActive ? 'nav-active' : ''}
                onClick={close}
              >
                {label}
              </NavLink>
            </li>
          ))}
        </ul>

        <Link to="/contact" className="btn-nav" onClick={close}>Book Now</Link>

        <button className="hamburger" ref={hamRef} onClick={toggleMenu} aria-label="Toggle menu">
          <span /><span /><span />
        </button>
      </div>
    </nav>
  );
}
